'use client';

import { normalizeUser, type AuthUser } from './shared';

/** ブラウザ側で /api/v1/auth/me を取る */
export async function fetchCurrentUserClient(): Promise<AuthUser | null> {
  try {
    const res = await fetch('/api/v1/auth/me', {
      method: 'GET',
      credentials: 'include',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const data: unknown = await res.json();
    return normalizeUser(data);
  } catch {
    return null;
  }
}

/** CSRF ヘッダ付き fetch（必要時のみ使用） */
export function csrfFetch(
  input: RequestInfo | URL,
  init: RequestInit & { csrfToken?: string }
): Promise<Response> {
  const { csrfToken, headers, ...rest } = init;
  return fetch(input, {
    ...rest,
    headers: {
      ...(headers ?? {}),
      ...(csrfToken ? { 'X-CSRFToken': csrfToken } : {}),
    },
    credentials: 'include',
  });
}
